<template>
  <v-card flat class="sub-site-wrapper">
    <div v-if="customerLoginStats" class="table-statistics-wrapper">
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Gesamtzahl der aktiven Kundenzugänge:</h5>
            <h3>{{ customerLoginStats.totalCustomerLogins }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Anzahl der Kunden mit mehreren Kundenzugängen:</h5>
            <h3>{{ customerLoginStats.customersWithMultipleLogins }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Anzahl der Kunden ohne Kundenzugänge:</h5>
            <h3>{{ customerLoginStats.customersWithNoLogins }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>
              Durchschnittliche Anzahl an Kundenzugängen pro aktivem Kunden:
            </h5>
            <h3>
              {{
                customerLoginStats.averageCustomerLoginsPerCustomer.toFixed(2)
              }}
            </h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Kunden mit 4 oder mehr Kundenzugängen:</h5>
            <h3>{{ customerLoginStats.customersWithMoreThanThree }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Kunden mit 4 oder mehr Kundenzugängen prozentual:</h5>
            <h3>
              {{ customerLoginStats.customersWithMoreThanThreePercentage }} %
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Kunden mit 6 oder mehr Kundenzugängen:</h5>
            <h3>{{ customerLoginStats.customersWithMoreThanFive }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="customerLoginStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Kunden mit 6 oder mehr Kundenzugängen prozentual:</h5>
            <h3>
              {{ customerLoginStats.customersWithMoreThanFivePercentage }} %
            </h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="statistics-text-box elevation-3">
            <h5>Informationen zu den Statistiken:</h5>
            <p>
              Es fließen nur Agenturen in die Statistik ein, die eine Stripe
              Subscription ID besitzen und mindestens einen Slot haben.
            </p>
            <p>
              Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  created() {
    this.loadStatistics();
  },
  computed: {
    ...mapState("statistics", [
      "customerLoginStats",
      "loading",
      "statisticsAge",
    ]),
  },
  methods: {
    ...mapActions("statistics", ["fetchMostRecentStatistic"]),
    async loadStatistics() {
      await this.fetchMostRecentStatistic();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
  padding: 24px;
}

.statistics-text-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-weight: 500;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  padding: 12px;
}
</style>
